// removed by extract-text-webpack-plugin
module.exports = {"indicator":"loading-indicator__indicator__3a42T","rotating":"loading-indicator__rotating__2MtrO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/loading-indicator.scss
// module id = 1220
// module chunks = 1